import { render, staticRenderFns } from "./CognitoSignIn.vue?vue&type=template&id=6de2dc31"
import script from "./CognitoSignIn.vue?vue&type=script&lang=js"
export * from "./CognitoSignIn.vue?vue&type=script&lang=js"
import style0 from "./CognitoSignIn.vue?vue&type=style&index=0&id=6de2dc31&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports